import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {getSellerReportDataApi} from "../../../../services/report";
import {getCustomerListApi} from "../../../../services/backStock";


export const getSalesReportData = createAsyncThunk('report/sales-report', async (data, {dispatch}) => {
    const response = await getSellerReportDataApi(data);
    dispatch(setTableRowCount(response.response.count))
    dispatch(setTotalAmount(response.response.total))
    return response.response.data;
});

export const getCustomerList = createAsyncThunk('report/sales-report/get-customer-list', async (data, {dispatch})=>{
    const response = await getCustomerListApi();
    return response.response;
});

const salesReportAdapter = createEntityAdapter({});

export const {selectAll: selectSalesReport, selectById: selectSalesReportById} = salesReportAdapter.getSelectors(
    state => state.report.salesReport
);

const salesReportSlice = createSlice({
    name: 'sellerReport',
    initialState: salesReportAdapter.getInitialState({
            id: null,
            searchText: '',
            salesReportTableRow:0,
            totalAmount:0,
            customers:'',
        }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.salesReportTableRow = action.payload;
        },
        setTotalAmount: (state, action) => {
            state.totalAmount = action.payload;
        },
        setCustomers: (state, action) => {
            state.customers = action.payload.customers;
        }
    },
    extraReducers: {
        [getSalesReportData.fulfilled] : salesReportAdapter.setAll
    }
});

export const {setTableRowCount,setTotalAmount, setCustomers} = salesReportSlice.actions;

export default salesReportSlice.reducer;